import {
  TableCell,
  Popover,
  Box,
  CircularProgress,
  Typography,
  Button,
} from '@mui/material'
import { grey } from '@mui/material/colors'
import React, { useRef, useState } from 'react'
import useCustomer from '../../hooks/api/useCustomer'
import { getIdentityName } from '../../utils/identity'

const CoalescedKeyLabel = ({ label, value }) => {
  return (
    <Typography>
      {label}:{' '}
      {value || <i style={{ color: grey[600], fontSize: '14px' }}>(None)</i>}
    </Typography>
  )
}

const PopoverContainer = ({ customerId, dropdowns }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { customer, isLoading } = useCustomer(customerId, { skip: !isOpen })
  const anchorRef = useRef(null)

  const primaryAccountOwner =
    customer?.accountOwners.find((ao) => ao.isPrimary) ||
    customer.accountOwners[0]
  const primaryAccountOwnerName = primaryAccountOwner
    ? getIdentityName(primaryAccountOwner)
    : null

  const customerUrl = `/customers/${customerId}?from=lists`

  return (
    <TableCell
      onMouseEnter={() => setIsOpen(true)}
      ref={anchorRef}
      sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}
    >
      <Popover
        open={isOpen}
        anchorEl={anchorRef.current}
        PaperProps={{
          onMouseLeave: () => setIsOpen(false),
        }}
      >
        <Box
          sx={{
            p: 2,
            minWidth: '300px',
            ...(isLoading ? { width: '300px', height: '200px' } : {}),
          }}
        >
          {isLoading && <CircularProgress />}
          {!isLoading && (
            <>
              <Button href={customerUrl}>
                <b>{customer?.name}</b>
              </Button>
              <Box sx={{ pl: 2 }}>
                <CoalescedKeyLabel
                  label={'Phone'}
                  value={customer.primaryPhone}
                />
                <CoalescedKeyLabel
                  label={'Email'}
                  value={customer.primaryEmail}
                />

                {Object.keys(customer.dropdowns || {}).map((d) => {
                  const dropdownType = dropdowns.find(
                    (dd) => `${dd.key}TypeId` === d
                  )

                  let label = dropdownType?.name
                  const value = customer.dropdowns[d]

                  let resolvedValue = dropdownType?.options.find(
                    (o) => o.id === value
                  )?.name

                  if (d === 'outcomeReasonTypeId') {
                    label = 'Outcome Reason'
                    let options = []
                    dropdowns
                      .filter((dd) => dd.key.includes('OutcomeReason'))
                      .forEach((dd) => {
                        options = options.concat(dd.options)
                      })

                    resolvedValue = options.find((o) => o.id === value)?.name
                  }

                  return (
                    <CoalescedKeyLabel
                      key={d}
                      label={label}
                      value={resolvedValue}
                    />
                  )
                })}
                <CoalescedKeyLabel
                  label={'Address'}
                  value={primaryAccountOwnerName}
                />
                <CoalescedKeyLabel
                  label={'Account owner'}
                  value={primaryAccountOwnerName}
                />
              </Box>
            </>
          )}
        </Box>
      </Popover>
    </TableCell>
  )
}

export default PopoverContainer
